import { createContext, useCallback, useContext, useState } from 'react';
import * as React from 'react';

import { EditCommentModal } from '@web/newsfeed/Article/ArticleComments/EditCommentModal/EditCommentModal';
import { ArticleComment } from '@web/newsfeed/types/Article';
import { EditCommentModalProviderState } from '@web/newsfeed/ArticleSearch/EditCommentModalProvider/editCommentModalProvider.types';

type Props = {
  children: React.ReactNode;
};

export const EditCommentModalStateContext = createContext<EditCommentModalProviderState>(
  {} as EditCommentModalProviderState
);
export const useEditCommentModalContext = () => useContext(EditCommentModalStateContext);

export const EditCommentModalProvider = ({ children }: Props) => {
  const [editComment, setEditComment] = useState<ArticleComment | null>(null);
  const onClose = useCallback(() => setEditComment(null), []);
  const setComment = useCallback((comment: ArticleComment) => setEditComment(comment), []);
  const value = {
    setEditComment: setComment,
  };

  return (
    <EditCommentModalStateContext.Provider value={value}>
      {children}

      <EditCommentModal comment={editComment} onClose={onClose} />
    </EditCommentModalStateContext.Provider>
  );
};
